import * as icons from '@coreui/icons'

export default defineNuxtPlugin((nuxtApp) => {

  const iconsSet = Object.assign({}, icons)

  nuxtApp.vueApp.provide('icons', iconsSet)

  nuxtApp.vueApp.config.globalProperties.$icons = iconsSet

  const iconsKey = 'icons'
  nuxtApp.vueApp.provide(iconsKey, iconsSet)

  nuxtApp.vueApp.directive('c-tooltip', {
    mounted(el, binding) {
      const tooltipText = binding.value

      const tooltip = document.createElement('div')
      tooltip.className = 'c-tooltip'
      tooltip.textContent = tooltipText

      document.body.appendChild(tooltip)

      el._tooltip = tooltip

      const showTooltip = (e: MouseEvent) => {
        const rect = el.getBoundingClientRect()
        tooltip.style.left = rect.left + (rect.width / 2) - (tooltip.offsetWidth / 2) + 'px'
        tooltip.style.top = rect.top - tooltip.offsetHeight - 8 + 'px'
        tooltip.style.opacity = '1'
      }
      
      const hideTooltip = () => {
        tooltip.style.opacity = '0'
      }
      
      el.addEventListener('mouseenter', showTooltip)
      el.addEventListener('mouseleave', hideTooltip)

      el._tooltipShow = showTooltip
      el._tooltipHide = hideTooltip
    },
    
    updated(el, binding) {
      const tooltipText = binding.value
      if (el._tooltip) {
        el._tooltip.textContent = tooltipText
      }
    },
    
    unmounted(el) {
      if (el._tooltipShow) {
        el.removeEventListener('mouseenter', el._tooltipShow)
      }
      if (el._tooltipHide) {
        el.removeEventListener('mouseleave', el._tooltipHide)
      }

      if (el._tooltip && el._tooltip.parentNode) {
        el._tooltip.parentNode.removeChild(el._tooltip)
      }
    }
  })
}) 